import React, { useEffect, useState } from 'react';

import { Cancel, CheckCircle } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const Skills = ({ data, setData, skills, setDisableSave, disableSave }) => {
  const [verify, setVerify] = useState({});
  const [skillData, setSkillData] = useState([]);

  useEffect(() => {
    if (Object.keys(verify).length > 0) {
      setDisableSave({ ...disableSave, skills: false });
    } else {
      setDisableSave({ ...disableSave, skills: true });
    }
  }, [verify]);

  useEffect(() => {
    if (skillData.length > 0) {
      setData({
        ...data,
        skills: [...skillData],
      });
    }
  }, [skillData]);

  return (
    <>
      <div className=' shadow-xl rounded-lg col-span-3'>
        <div className='bg-gray-200 py-2 px-4 text-[#134F5C] text-base font-semibold'>
          Skills
        </div>
        {/* </div> */}
        <div className=' flex py-4'>
          <div className='flex flex-wrap gap-2 w-3/4 py-4 ml-2'>
            {skills.length > 0 &&
              skills.map((exp, index) => {
                return (
                  <div
                    className='flex p-3 px-8 w-auto border-solid rounded-full border border-blue-c1 bg-blue-c1 text-white'
                    key={index}
                  >
                    <div className=' opacity-80 text-base'>{exp}</div>
                  </div>
                );
              })}
          </div>
          <span className='w-1/4 flex items-center justify-between'>
            <span className=' opacity-60 text-sm'>
              {verify.skills === 'yes' && 'Approve'}
              {verify.skills === 'no' && 'Reject'}
            </span>
            <span>
              <IconButton
                onClick={() => {
                  setVerify({ ...verify, skills: 'yes' });
                  setSkillData([...skills]);
                }}
                className='focus:outline-none'
              >
                <CheckCircle
                  htmlColor={verify.skills === 'yes' ? '#76CE65' : 'inherit'}
                />
              </IconButton>
              <IconButton
                onClick={() => {
                  setVerify({ ...verify, skills: 'no' });
                }}
              >
                <Cancel
                  htmlColor={verify.skills === 'no' ? '#CC0000' : 'inherit'}
                />
              </IconButton>
            </span>
          </span>
        </div>
      </div>
    </>
  );
};

export default Skills;
